import { render, staticRenderFns } from "./Inscription-picture.vue?vue&type=template&id=f8fb7bb8&scoped=true&"
import script from "./Inscription-picture.vue?vue&type=script&lang=js&"
export * from "./Inscription-picture.vue?vue&type=script&lang=js&"
import style0 from "./Inscription-picture.vue?vue&type=style&index=0&id=f8fb7bb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fb7bb8",
  null
  
)

export default component.exports